import React from 'react';
import { Box, IconButton, Slide } from '@material-ui/core';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import defaultLocales from 'globals/locales/default';
import FsSimpleInput from 'ui-elements/form-elements/FsDefaultInput/FsDefaultInput';
import FsFormGridWrapper from 'ui-elements/form-elements/FsFormGridWrapper';
import FsFormGridItem from 'ui-elements/form-elements/FsFormGridItem';

export interface NotificationSettingsSingleRowDataProps {
  id: number;
  email: string;
}

export interface NotificationSettingsSingleRowProps
  extends NotificationSettingsSingleRowDataProps {
  onRemove?: () => void;
  onChange?: ({ email }: NotificationSettingsSingleRowDataProps) => void;
  isFirst?: boolean;
}

const NotificationSettingsSingleRow: React.FC<NotificationSettingsSingleRowProps> = ({
  email = '',
  id,
  onRemove,
  onChange,
  isFirst,
}) => {
  const handleClick = async () => {
    if (onRemove) onRemove();
  };

  const handleChange = async (newValue: string) => {
    if (onChange) onChange({ id, email: newValue });
  };

  return (
    <Slide direction="left" in timeout={300}>
      <Box>
        <FsFormGridWrapper>
          <FsFormGridItem>
            <FsSimpleInput
              fsVariant="outlined"
              fullWidth
              name={defaultLocales.email.toLowerCase()}
              label={defaultLocales.email}
              value={email}
              onChange={(e) => handleChange(e.target.value)}
            />
          </FsFormGridItem>
          <FsFormGridItem style={{ flexGrow: 0 }}>
            <Box display="flex" alignItems="center">
              {!isFirst ? (
                <IconButton onClick={handleClick}>
                  <DeleteOutlineOutlinedIcon />
                </IconButton>
              ) : (
                <Box width={48} />
              )}
            </Box>
          </FsFormGridItem>
        </FsFormGridWrapper>
      </Box>
    </Slide>
  );
};

export default NotificationSettingsSingleRow;
